(angular => {
  "use strict";

  angular.module("App")
    .constant("API", "/api/public")
    .config(["$routeProvider", configRouter])
    .config(["$httpProvider", configInterceptor])
    .run(["$rootScope", "$location", "$timeout", "AuthService", "LoginService", run]);

  function configRouter($routeProvider) {
    $routeProvider.otherwise({ redirectTo: "/" });
  }

  function configInterceptor($httpProvider) {
    $httpProvider.defaults.headers.common["Cache-Control"] = "no-cache";
    $httpProvider.defaults.cache = false;

    if (!$httpProvider.defaults.headers.get) {
      $httpProvider.defaults.headers.get = {};
    }

    $httpProvider.defaults.headers.get["If-Modified-Since"] = "0";
    $httpProvider.interceptors.push("authInterceptor");
  }

  function run($rootScope, $location, $timeout, authService, LoginService) {
    if ($location.search().t) {
      authService.removeToken();
    }

    $rootScope.$on("$routeChangeStart", ($event, next) => {
      if (!next.$$route || next.$$route.allowAnonymous || next.redirectTo) {
        return true;
      }

      if (!authService.isLoggedIn()) {
        $event.preventDefault();
        $location.path("/");
        return;
      }


      if (authService.isLoggedIn()) {
        const user = authService.getTokenData();
        if (user.preview && !next.$$route.allowPreview) {
          $event.preventDefault();
          $location.path("/dashboard");
          return false;
        }

        return true;
      }

      $event.preventDefault();
      $location.path("/");
    });

    $rootScope.$on("$routeChangeError", LoginService.logout);
  }

})(angular);
